import React, { useState } from "react";
import { industries } from "../mock";
import { Factory, ShoppingBag, Package, Cpu, Landmark } from "lucide-react";

const iconMap = { CPG: Package, Retail: ShoppingBag, Manufacturing: Factory, Technology: Cpu, "Financial Services": Landmark };

const Industries = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="industries" className="py-24 bg-[#F5F7FB]">
      <div className="container-x">
        <div className="max-w-3xl reveal">
          <span className="tag-chip">Industries</span>
          <h2 className="section-title mt-4">Data engineering solutions by industry</h2>
          <p className="section-sub mt-5">
            Every industry has unique data complexity. Our services are tailored to your sector’s regulatory, operational, and analytical requirements.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-6">
          <div className="lg:col-span-4 flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible">
            {industries.map((ind, i) => {
              const Icon = iconMap[ind.name] || Cpu;
              return (
                <button
                  key={ind.name}
                  onClick={() => setActive(i)}
                  className={`flex items-center gap-3 px-5 py-4 rounded-xl border transition-all shrink-0 lg:w-full text-left ${
                    active === i
                      ? "bg-[#0B1B3B] border-[#0B1B3B] text-white"
                      : "bg-white border-slate-200 text-slate-700 hover:border-[#1E56E3]/40"
                  }`}
                >
                  <span className={`h-9 w-9 rounded-lg flex items-center justify-center ${active === i ? "bg-[#1E56E3]" : "bg-[#EEF3FF] text-[#1E56E3]"}`}>
                    <Icon size={16} />
                  </span>
                  <span className="font-semibold">{ind.name}</span>
                </button>
              );
            })}
          </div>

          <div className="lg:col-span-8">
            <div key={active} className="reveal visible bg-white border border-slate-200 rounded-2xl p-8 md:p-10">
              <h3 className="text-2xl font-bold text-[#0B1B3B]">{industries[active].name}</h3>
              <p className="mt-4 text-[15px] text-slate-600 leading-relaxed">{industries[active].desc}</p>
              <a href="#contact" className="btn-primary mt-6">Discuss Your Use Case</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
